
(function(){
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer:fine)').matches;

  function toast(msg){
    var t=document.getElementById('bpToast'); if(!t)return;
    t.textContent=msg; t.classList.add('is-on');
    clearTimeout(t._t); t._t=setTimeout(function(){t.classList.remove('is-on')},2800);
  }
  window.bpToast = toast;

  function tilt(root, sel, baseY){
    if(calm||!fine) return;
    var els=[].slice.call(root.querySelectorAll(sel));
    root.addEventListener('pointermove',function(e){
      var r=root.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
      els.forEach(function(el){
        el.style.setProperty('--ry',(x*14+(baseY||0)).toFixed(2)+'deg');
        el.style.setProperty('--rx',(-y*9).toFixed(2)+'deg');
      });
    });
    root.addEventListener('pointerleave',function(){
      els.forEach(function(el){el.style.setProperty('--ry',(baseY||0)+'deg');el.style.setProperty('--rx','0deg')});
    });
  }

  /* hero sliders */
  [].forEach.call(document.querySelectorAll('[data-bp-slider]'),function(root){
    var slides=[].slice.call(root.querySelectorAll('.bp-slide'));
    var dots=[].slice.call(root.querySelectorAll('.bp-dot'));
    if(!slides.length) return;
    var i=0,timer=null,speed=(parseInt(root.dataset.speed,10)||7)*1000;
    function show(n){
      i=(n+slides.length)%slides.length;
      slides.forEach(function(s,k){s.classList.toggle('is-on',k===i)});
      dots.forEach(function(d,k){d.setAttribute('aria-current',k===i)});
    }
    function play(){ if(calm||slides.length<2)return; stop(); timer=setInterval(function(){show(i+1)},speed); }
    function stop(){ if(timer){clearInterval(timer);timer=null;} }
    root.querySelectorAll('[data-go]').forEach(function(b){b.addEventListener('click',function(){show(+b.dataset.go);play()})});
    root.querySelectorAll('[data-step]').forEach(function(b){b.addEventListener('click',function(){show(i+ +b.dataset.step);play()})});
    root.addEventListener('pointerenter',stop); root.addEventListener('focusin',stop); root.addEventListener('pointerleave',play);
    tilt(root,'.bp-3d',0);
    play();
  });

  /* video banners */
  [].forEach.call(document.querySelectorAll('[data-bp-video]'),function(root){
    var v=root.querySelector('video'), btn=root.querySelector('.bp-sound');
    if(v&&btn){
      btn.addEventListener('click',function(){
        v.muted=!v.muted;
        btn.setAttribute('aria-label',v.muted?'Unmute video':'Mute video');
        if(!v.muted){v.play();}
      });
    }
    if(v&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(e){e.isIntersecting?v.play().catch(function(){}):v.pause()})},{threshold:.25}).observe(v);
    }
    tilt(root,'.bp-v3d',-7);
  });

  /* mobile nav */
  var burger=document.querySelector('[data-bp-burger]');
  if(burger){
    burger.addEventListener('click',function(){
      var nav=document.querySelector('[data-bp-nav]');
      var open=nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded',open);
    });
  }

  /* modals */
  document.addEventListener('click',function(e){
    var open=e.target.closest('[data-bp-open]');
    if(open){ var m=document.getElementById(open.dataset.bpOpen); if(m){m.hidden=false;document.body.style.overflow='hidden';} }
    var close=e.target.closest('[data-bp-close]');
    if(close){ var mm=close.closest('.bp-modal'); if(mm){mm.hidden=true;document.body.style.overflow='';} }
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      [].forEach.call(document.querySelectorAll('.bp-modal'),function(m){m.hidden=true});
      document.body.style.overflow='';
    }
  });

  /* product gallery + variants */
  var pdp=document.querySelector('[data-bp-product]');
  if(pdp){
    var main=pdp.querySelector('[data-bp-main-image]');
    pdp.querySelectorAll('.bp-thumb').forEach(function(t){
      t.addEventListener('click',function(){
        pdp.querySelectorAll('.bp-thumb').forEach(function(x){x.setAttribute('aria-current','false')});
        t.setAttribute('aria-current','true');
        if(main){ main.src=t.dataset.full; main.srcset=''; }
      });
    });

    var data=pdp.querySelector('[data-bp-variants]');
    if(data){
      var variants=JSON.parse(data.textContent);
      var idField=pdp.querySelector('[data-bp-variant-id]');
      var priceEl=pdp.querySelector('[data-bp-price]');
      var wasEl=pdp.querySelector('[data-bp-was]');
      var addBtn=pdp.querySelector('[data-bp-add]');
      var waBtn=pdp.querySelector('[data-bp-wa]');
      var money=data.dataset.moneyFormat||'{{amount}}';

      function fmt(cents){
        var n=(cents/100).toLocaleString(undefined,{minimumFractionDigits:0,maximumFractionDigits:2});
        return money.replace(/\{\{\s*amount[^}]*\}\}/,n);
      }
      function selected(){
        return [].slice.call(pdp.querySelectorAll('[data-bp-option]:checked')).map(function(r){return r.value});
      }
      function update(){
        var chosen=selected();
        var match=variants.filter(function(v){
          return v.options.every(function(o,k){return o===chosen[k]});
        })[0];
        pdp.querySelectorAll('[data-bp-option-name]').forEach(function(el){
          var idx=+el.dataset.bpOptionName;
          el.textContent=chosen[idx]||'';
        });
        if(!match){
          if(addBtn){addBtn.disabled=true;addBtn.textContent='Unavailable';}
          return;
        }
        if(idField) idField.value=match.id;
        if(priceEl) priceEl.textContent=fmt(match.price);
        if(wasEl){
          if(match.compare_at_price&&match.compare_at_price>match.price){
            wasEl.textContent=fmt(match.compare_at_price); wasEl.hidden=false;
          } else { wasEl.hidden=true; }
        }
        if(addBtn){
          addBtn.disabled=!match.available;
          addBtn.textContent=match.available?(addBtn.dataset.label||'Add to bag'):'Sold out';
        }
        if(waBtn){
          var base=waBtn.dataset.base||'';
          var msg=base+'\n\nProduct: '+data.dataset.title+'\nOption: '+chosen.join(' / ')+'\nPrice: '+fmt(match.price);
          waBtn.href='https://wa.me/'+waBtn.dataset.number+'?text='+encodeURIComponent(msg);
        }
        if(history.replaceState){
          var url=new URL(window.location.href);
          url.searchParams.set('variant',match.id);
          history.replaceState({},'',url);
        }
      }
      pdp.querySelectorAll('[data-bp-option]').forEach(function(r){r.addEventListener('change',update)});
      update();
    }

    var qty=pdp.querySelector('[data-bp-qty]');
    if(qty){
      pdp.querySelectorAll('[data-bp-qty-step]').forEach(function(b){
        b.addEventListener('click',function(){
          var n=parseInt(qty.value,10)||1;
          qty.value=Math.max(1,n+parseInt(b.dataset.bpQtyStep,10));
        });
      });
    }
  }
})();
